import "./styles.less";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { CloseCircleFilled } from "@ant-design/icons";
import { ImagenOptimizada } from "../../Image/web";
import dynamic from "next/dynamic";
const Modal = dynamic(
	() => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);
import { useBannerPopUp } from "./BannerPopUp.hook";

const LOCAL_STORAGE_KEY = "popup_dinamico";

export const BannerPopUp = () => {
	const { pathname } = useRouter();
	const { data, error } = useBannerPopUp({ where: getWhereFromPathname(pathname) });
	const [isOpen, setOpen] = useState(false);

	useEffect(() => {
		const lastTime = localStorage?.getItem(LOCAL_STORAGE_KEY);
		if (data && (!lastTime || Date.now() - parseInt(lastTime) > 1000 * 60 * 60 * 24)) {
			setOpen(true);
			let date = Date.now();
			localStorage.setItem(LOCAL_STORAGE_KEY, date.toString());
		} else if (error) {
			setOpen(false);
		}
	}, [data, error]);

	if (!isOpen) return null;

	if (data.video != null) {
		data["video_ext"] = data.video
			.split(/\#|\?/)[0]
			.split(".")
			.pop()
			.trim();
	}

	const onClose = () => setOpen(false);

	const normalPopup = (
		<Modal
			width="740px"
			classes="modal-transparent"
			background="transparent"
			onClose={onClose}
			show={isOpen}>
			<div className="modal-popup">
				<div className="content">
					<a
						target="_blank"
						href={data.url}
						title={data.title}
						className="link"
						onClick={() => onClose()}>
						{data.video != null ? (
							<video autoPlay loop muted poster={data.video_thumbnail}>
								<source src={data.video} type={"video/" + data.video_ext} />
							</video>
						) : (
							<picture>
								{data.mobile_image != null ? (
									<source media="(max-width: 980px)" srcSet={data.mobile_image} />
								) : null}
								<ImagenOptimizada src={data.image} alt={data.title} />
							</picture>
						)}
					</a>
				</div>
			</div>
		</Modal>
	);

	const htmlPopup = (
		<div className="html-popup">
			<CloseCircleFilled className="close" onClick={() => onClose()} />
			<iframe src={data.html} />
		</div>
	);

	return <>{data.html ? htmlPopup : normalPopup}</>;
};
// aux
const getWhereFromPathname = (pathname: string) => {
	if (pathname.indexOf("home") >= 0) return "portadainit";
	else if (pathname.indexOf("search") >= 0) return "propiedadeslistar";
	else if (pathname.indexOf("prop") >= 0 || pathname.indexOf("project") >= 0)
		return "propiedadesampliar";
	return "portadainit";
};

